module.exports = __webpack_public_path__ + "img/collar_width.f9814eb4.png";